let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fvacK")).then(() => parcelRequire('lns8o'));